// extracted by mini-css-extract-plugin
export default {"heading":"Business_heading__4elJV","wrapper":"Business_wrapper__0xkwo"};